// Copyright (c) 2024-2026 Noushad Khalid / Codeteki. All rights reserved.
// Licensed under the Elastic License 2.0 — see LICENSE for details.

/** Google Play (live) + App Store (coming soon) badges — shared between
 * the homepage and /ai-tools so the pitch and links stay in sync. */
export default function MobileAppBadges({ className = "" }) {
  return (
    <section className={`py-16 bg-gray-50 border-y border-gray-100 ${className}`}>
      <div className="container mx-auto px-4 text-center max-w-2xl">
        <h2 className="text-2xl md:text-3xl font-bold text-[#020617] mb-3">
          Also on your phone, iPad &amp; tablet
        </h2>
        <p className="text-gray-500 text-base mb-8 leading-relaxed">
          Spanner, AI Chat Widget, Instant Quote and Service Reminders — all in one app.
          Available now on Android, iPad &amp; tablet. iPhone — coming soon.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="https://play.google.com/store/apps/details?id=au.codeteki.app"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 border-2 border-[#020617] rounded-2xl px-5 py-3 hover:bg-[#020617] hover:text-white transition-colors group"
          >
            <svg className="w-7 h-7 flex-shrink-0" viewBox="0 0 24 24">
              <path fill="#f9cb07" d="M3.6 2.3c-.4.3-.6.8-.6 1.4v16.6c0 .6.2 1.1.6 1.4l.1.1L13 12.5v-.1L3.7 2.2l-.1.1z"/>
              <path className="fill-[#020617] group-hover:fill-white transition-colors" d="M16.1 15.6l-3.1-3.1v-.1l3.1-3.1 6.9 4c1 .5 1 1.3 0 1.9l-6.9 4.4z"/>
              <path className="fill-[#020617] group-hover:fill-white transition-colors" d="M16.1 15.6L13 12.5 3.6 21.9c.35.36.9.4 1.6.05l10.9-6.35z"/>
              <path className="fill-[#020617] group-hover:fill-white transition-colors" d="M16.1 9.4L5.2 3.05c-.7-.35-1.25-.3-1.6.05L13 12.5l3.1-3.1z"/>
            </svg>
            <span className="text-left leading-tight">
              <span className="block text-[10px] font-semibold uppercase tracking-wide opacity-60">Get it on</span>
              <span className="block text-base font-bold">Google Play</span>
            </span>
          </a>
          <div className="inline-flex items-center gap-3 border-2 border-gray-200 rounded-2xl px-5 py-3 text-gray-400 cursor-not-allowed">
            <svg className="w-7 h-7 flex-shrink-0" viewBox="0 0 24 24">
              <path fill="currentColor" d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.572-2.27 1.206-2.98.744-.85 2.037-1.52 3.107-1.55.03.1.03.2.03.3zm4.607 16.44c-.28.62-.4 1.02-.75 1.65-.5.9-1.19 2.03-2.05 2.04-.77.01-.97-.5-2.01-.5-1.04 0-1.28.49-2.04.51-.86.03-1.5-.98-2-1.87-1.4-2.5-1.65-5.44-.73-7.15.65-1.2 1.83-1.96 3.1-1.98.79-.02 1.53.53 2.01.53.48 0 1.39-.66 2.34-.56.4.02 1.5.16 2.22 1.2-.06.04-1.32.77-1.31 2.3.02 1.83 1.6 2.44 1.62 2.45.02.04-.32 1.4-.42 1.72z"/>
            </svg>
            <span className="text-left leading-tight">
              <span className="block text-[10px] font-semibold uppercase tracking-wide opacity-70">Coming soon on the</span>
              <span className="block text-base font-bold">App Store</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
